import wv from '@cpc/comment-sdk-jsapi';

export interface InfoInterafce {
  browserVersion: string;
}

export interface BrowserInfoInterface {
  code: number;
  data: InfoInterafce;
}

export interface BrowserVersionInterface {
  getColorOsVersion: () => string;
  getBrowserUIVersion: () => string;
  isBrowserVersionHigherThan: (
    baseVersion: string,
    currentVersion: string,
    containEqual: boolean,
  ) => boolean;
}

export function useBrowserVersion(): BrowserVersionInterface {
  const isBrowserVersionHigherThan = function (
    baseVersion: string,
    currentVersion: string,
    containEqual = true,
  ): boolean {
    try {
      const parseVersion = (versionArr: string[] | number[]): number => {
        // 给大版本号一个权重，防止 8.1 < 7.26 的现象
        // [8000, 1] [7000, 39]
        return versionArr[0] * 1000 + versionArr[1] * 1;
      };
      // 转换成数字的版本，方便比较
      const versionToNum = (version: string): number => {
        let cruVersion: string[] = version.split('.');

        if (cruVersion.length >= 4) {
          // 去掉前面的 10/20/40
          cruVersion = cruVersion.slice(1, 4);
        }

        // 去掉最后的小版本号
        cruVersion = cruVersion.slice(0, -1);

        return Number(parseVersion(cruVersion));
      };

      let version = currentVersion;

      if (!currentVersion) {
      // 没传版本时，取 ua 上的版本
        const ua = window.navigator.userAgent.toLowerCase();
        const regExpUa = /(oppo|nearme|realme|oneplus|heytap)browser\/([0-9.]+)/i;
        const matched = ua.match(regExpUa);

        if (matched && matched.length === 3) {
          version = matched[2];
        }
      } else {
        // 去掉版本号最后可能存在的 der 等后缀
        const regExpNum = /[0-9.]+/;
        const matched = version.match(regExpNum);

        if (matched) {
          version = matched[0];
        }
      }

      if (version) {
        const baseVersionNum = Number(parseVersion((`${baseVersion}`).split('.')));

        return containEqual
          ? versionToNum(version) >= baseVersionNum
          : versionToNum(version) > baseVersionNum;
      }

      return false;
    } catch (e) {
      return false;
    }
  };

  /**
   * 根据浏览器版本区分os版本适配ui
   * @param {*} wv 可不传 JSAPI 实例对象
   * @returns {String} 11|12|13 等等
   */
  const getColorOsVersion = function (): string {
    const browserInfo: BrowserInfoInterface = wv && wv.invoke('getBrowserInfo');
    const browserVersion: string
      = browserInfo && browserInfo.data && browserInfo.data.browserVersion;
    console.log('getColorOsVersion browserVersion', browserVersion);
    let styling = '13';

    if (wv.isMethodValid('BrowserNormal.getUIVersion')) {
      // 当前适配到os15
      styling = String(Math.min(window.BrowserNormal.getUIVersion(), 16));

      return styling;
    }

    if (!isBrowserVersionHigherThan('7.26', browserVersion)) {
      // <7.26
      styling = '11';
    } else if (!isBrowserVersionHigherThan('7.40', browserVersion)) {
      // [7.26,7.40)
      styling = '12';
    }

    console.log('getColorOsVersion:', styling);

    return styling;
  };

  /**
   * 根据浏览器版本适配ui
   *  浏览器v8.22 && wv.isMethodValid('BrowserNormal.getUIVersion')开始
   * @returns {String} 22|23|24 等等
  */
  const getBrowserUIVersion = function (): string {
    const browserInfo: BrowserInfoInterface = wv && wv.invoke('getBrowserInfo');
    const browserVersion: string
      = browserInfo && browserInfo.data && browserInfo.data.browserVersion;
    let browserUIAdaptation = '22';

    if (wv.isMethodValid('BrowserNormal.getUIVersion')) {
      if (!isBrowserVersionHigherThan('8.22', browserVersion)) {
        browserUIAdaptation = '21';
      }
      return browserUIAdaptation;
    }

    console.log('getBrowserUIVersion:', browserUIAdaptation);

    return browserUIAdaptation;
  };

  return {
    getColorOsVersion,
    getBrowserUIVersion,
    isBrowserVersionHigherThan,
  };
}
